module.exports = __webpack_public_path__ + "img/i-sec03-img.d51ed0a9.png";